var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: { label: _vm.label, "class-name": _vm.formLabelClassName },
    scopedSlots: _vm._u(
      [
        {
          key: "label",
          fn: function () {
            return [_vm._t("label")]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "fieldset",
                [
                  _vm._l(_vm.options, function (option, i) {
                    return [
                      _c(
                        "label",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: { content: option.description },
                              expression: "{ content: option.description}",
                            },
                          ],
                          key: i,
                          staticClass: "pega-input",
                          class: _vm.labelClassName,
                        },
                        [
                          _c("input", {
                            class: _vm.className,
                            attrs: {
                              "data-test": "option-" + i,
                              type: _vm.type,
                              name: _vm.name,
                              disabled: _vm.disabled,
                            },
                            domProps: {
                              value: option.id,
                              checked: _vm.value.includes(option.id),
                            },
                            on: { change: _vm.update },
                          }),
                          _c("span", { class: _vm.valueClassName }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.name) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.mailFlag
                ? _c("div", [
                    _c("div", { attrs: { "data-test": "mail-text" } }, [
                      _vm._v(
                        "\n        ※メール受信設定は、各アカウントで設定・変更できます。詳細は\n        "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "mailGuide",
                          attrs: {
                            "data-test": "guide-link",
                            href: "/help/faq/index_287.html",
                            target: "_blank",
                          },
                        },
                        [_vm._v("\n          こちら\n        ")]
                      ),
                      _vm._v("\n        をご参照ください。\n      "),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "error",
          fn: function () {
            return [_vm._t("error")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }